import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  setSessionInvalidationHandler,
  clearSessionInvalidationHandler,
} from '../utils/sessionInvalidation';

/**
 * Registers global handler for API 401 / session 403: logout, clear client session, go to /login.
 */
export default function SessionInvalidationBridge({ children }) {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const busy = useRef(false);

  useEffect(() => {
    setSessionInvalidationHandler(async ({ message } = {}) => {
      if (busy.current) return;
      const path = typeof window !== 'undefined' ? window.location.pathname || '' : '';
      if (path === '/login' || path === '/otp') return;

      busy.current = true;
      try {
        await logout();
      } catch {
        /* logout already best-effort */
      } finally {
        const text =
          message && String(message).trim()
            ? String(message).trim()
            : 'Your session has ended. Please sign in again.';
        navigate('/login', {
          replace: true,
          state: { authMessage: text, sessionExpired: true },
        });
        window.setTimeout(() => {
          busy.current = false;
        }, 1500);
      }
    });

    return () => clearSessionInvalidationHandler();
  }, [logout, navigate]);

  return children;
}
